import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { RoundRestoreUtil } from '@/utils/RoundRestoreUtil'
import { BaseState } from '@stateMachine/BaseState'
import { TranslationUtils } from '@modules/src/utils/TranslationUtils'
import { WinningUtil } from '@/managers/winning/WinningUtil'
import { SymbolData } from '@/modules'
import { SpecialSymbolType } from '@/containers/symbols/SpecialSymbolType'
import { Utilities } from '@base/utils/Utilities'
import Facade from '@/Facade'

export class RestoreState extends BaseState {
    private _nextState: GameStatesEnum
    private _autoContinueTimeoutId: number = null

    public begin(): void {
        this._nextState = GameStatesEnum.IDLE_STATE

        const spinData = this._model.spinData
        if (!spinData) {
            this.end()
            return
        }

        const { base_win_currency, freebet } = spinData

        if (!!freebet && !!freebet.amount_left && !this._model.isPromoSpinsRound()) {
            this._restoreFreeSpinsSession()
            return
        }

        if (
            !this._model.spinData.freeround &&
            Utilities.isLocalStorageAvailable() &&
            JSON.parse(localStorage.getItem(`${Facade.urlParams.playerUid}_freeround`))
        ) {
            this._model.spinData.freeround = JSON.parse(localStorage.getItem(`${Facade.urlParams.playerUid}_freeround`))
        }

        if (false) {
            this._model.bigWinLevel = WinningUtil.getBigWinLevel(base_win_currency, this._model.currentBaseBet)

            if (!!freebet) {
                // skipping summary dialog, if round active flag is not set
                if (RoundRestoreUtil.isRoundActive() && !!freebet.amount_left) {
                    this._restoreFreeSpinsSession()
                    return
                }
            }

            if (!!this._model.spinData.freeround) {
                if (RoundRestoreUtil.isRoundActive() || !!this._model.spinData.freeround.amount_left) {
                    this._restoreFreeRoundsSession()
                    return
                }
            }

            this._restoreSession()
            return
        }

        this.end()
    }

    private _restoreFreeRoundsSession(): void {
        GameSignals.freeRoundsActive.emit()
        this.end()
    }

    private _restoreFreeSpinsSession(): void {
        const { bonus, freebet, win_currency } = this._model.spinData

        this._nextState = GameStatesEnum.START_ROUND_STATE
        this._model.roundState.isRestoredRound = true
        this._model.winCounter.startRound()

        this._waitRestoreConfirmationOrContinue()
        GameSignals.enableGamePopups.emit()
        GameSignals.previousRoundActive.emit()
        GameSignals.roundStart.emit(true)

        if (freebet.amount_left === freebet.total_amount_given) {
            bonus.freebet_given = freebet.total_amount_given
        } else {
            this._model.winCounter.countWin(
                freebet.total_win + (freebet.triggered_win_amount_currency || 0) - (win_currency || 0),
                0
            )

            const initMultiplier: number = this._getInitMultiplier()
            if (initMultiplier > 0) {
                GameSignals.updateJarValue.emit(initMultiplier, false)
            }

            if (freebet.amount_left === 0) {
                GameSignals.balanceHasChanged.emit(
                    this._model.balance - (freebet.total_win + freebet.triggered_win_amount_currency)
                )
            }

            this._model.isBonusGameNow = false
            this._model.roundState.isFreeSpins = false
        }
    }

    private _restoreSession(): void {
        if (RoundRestoreUtil.isRoundActive()) {
            if (this._model.spinData.slot_grid.length > 1 && this._model.spinData.winning_combinations.length > 1) {
                this._nextState = GameStatesEnum.CASCADE_STATE
                GameSignals.balanceHasChanged.emit(this._model.balance - this._model.spinData.win_currency)

                const initMultiplier: number = this._getInitMultiplier()
                if (initMultiplier > 0) {
                    GameSignals.updateJarValue.emit(initMultiplier, false)
                }
            }

            this._waitRestoreConfirmationOrContinue()
            GameSignals.previousRound.emit()
            //RoundRestoreUtil.stopRound()
            return
        }

        this.end()
    }

    private _getInitMultiplier = (): number => {
        let multiplier: number = 0

        this._model.spinData.slot_grid[0].forEach((reel: SymbolData[]) => {
            reel.forEach((symbolData: SymbolData) => {
                if (symbolData.id === SpecialSymbolType.MULTIPLIER) {
                    multiplier += symbolData.multiplier
                }
            })
        })

        return multiplier
    }

    public end = (button: string = null) => {
        const okButton = TranslationUtils.translate('okButton')

        if (button == null || button === `ui-dialog-btn_${okButton}`) {
            this._stateMachine.setState(this._nextState || GameStatesEnum.IDLE_STATE)
        }
    }

    public cleanUp() {
        if (this._autoContinueTimeoutId !== null) {
            clearTimeout(this._autoContinueTimeoutId)
            this._autoContinueTimeoutId = null
        }

        GameSignals.buttonClicked.disconnect(this.end)
    }

    private _waitRestoreConfirmationOrContinue(): void {
        GameSignals.buttonClicked.connect(this.end)
    }
}
